export default __webpack_public_path__ + "static/media/newbasement.cf09f749.svg";